<template>
    <div :class="`base ${noticeType} ${alignment}`">
        <slot name="content"></slot>
    </div>
</template>

<script>
    export default {
        props: {
            noticeType: {
                required: false,
                default: 'notice'
            }, 
            alignment: {
                required: false,
                default: 'center'
            }
        },
    }
</script>

<style scoped>

    .base {
        margin: 10px;
        padding: 20px;
        border-radius: 8px;
    }

    .notice {
        color: #9F6000;
        font-size: 18px;
        font-weight: bold;
        background-color: #FEEFB3;
        margin-top: 30px !important;
    }

    .info {
        color: #17191C;
        text-align: center;
        font-size: 18px;
        font-weight: bold;
        background-color: #F6F7F9;
    }

    .banner {
        color: #00263E;
        text-align: center;
        font-size: 18px;
        font-weight: bold;
        background-color: #F2F7FF;
    }

    .center {
        text-align: center;
    }

    .left {
        text-align: left
    }

    .right {
        text-align: right;
    }

    .error {
        color: #D8000C;
        text-align: center;
        font-size: 18px;
        font-weight: bold;
        background-color: #FFD2D2;
    }

</style>
